import React from 'react';

import classes from './SubTopicInput.module.css';
import CloseIcon from '../../../assets/icons/icon-close-black.svg';

const SubTopicInput = (props) => {
    return (
        <>
            <div className={classes.SubtopicInputContainer}>
                <div className={classes.TextInputContainer}>
                    <div className={classes.InputContainer}>
                        <label className={classes.SubTopicInputLabel}>Concept {props.pos + 1}</label>
                        <input
                            type="text"
                            placeholder={"Subtopic " + (props.pos + 1)}
                            value={props.data.value}
                            className={classes.TextInput}
                            disabled={props.disabled ? true : false}
                            onChange={(event) => props.onInputChanged(event, props.pos, 'objective')} />
                        {/* <p className={classes.RemainingChar}>{props.data.remainingChar} characters</p> */}
                        <p className={classes.ErrorMessage}>{props.errorMessage}</p>
                    </div>
                    {
                        props.pos !== 0
                            ? props.disabled !== true
                                ? <img src={CloseIcon} alt="remove subtopic" className={classes.RemoveIcon}
                                    onClick={() => props.removeSubtopicClicked(props.pos)} />
                                : null
                            : null
                    }
                </div>
            </div>
        </>
    );
}

export default SubTopicInput;